import { createIcon } from '@chakra-ui/react';

export const EyeBoldIcon = createIcon({
  displayName: 'EyeBoldIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="25"
        // height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M21.75 9.14969C19.44 5.51969 16.06 3.42969 12.5 3.42969C10.72 3.42969 8.99 3.94969 7.41 4.91969C5.83 5.89969 4.41 7.32969 3.25 9.14969C2.25 10.7197 2.25 13.2697 3.25 14.8397C5.56 18.4797 8.94 20.5597 12.5 20.5597C14.28 20.5597 16.01 20.0397 17.59 19.0697C19.17 18.0897 20.59 16.6597 21.75 14.8397C22.75 13.2797 22.75 10.7197 21.75 9.14969ZM12.5 16.0397C10.26 16.0397 8.46 14.2297 8.46 11.9997C8.46 9.76969 10.26 7.95969 12.5 7.95969C14.74 7.95969 16.54 9.76969 16.54 11.9997C16.54 14.2297 14.74 16.0397 12.5 16.0397Z"
          fill="#6E6789"
        />
        <path
          d="M12.5004 9.13965C10.9304 9.13965 9.65039 10.4196 9.65039 11.9996C9.65039 13.5696 10.9304 14.8496 12.5004 14.8496C14.0704 14.8496 15.3604 13.5696 15.3604 11.9996C15.3604 10.4296 14.0704 9.13965 12.5004 9.13965Z"
          fill="#6E6789"
        />
      </svg>
    </>
  ),
});
